import { render } from "./TradingOverlay.vue?vue&type=template&id=4095b7de&scoped=true&ts=true"
import script from "./TradingOverlay.vue?vue&type=script&lang=ts"
export * from "./TradingOverlay.vue?vue&type=script&lang=ts"

import "./TradingOverlay.vue?vue&type=style&index=0&id=4095b7de&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4095b7de"]])

export default __exports__